import { render, staticRenderFns } from "./RelatedProductsV2.vue?vue&type=template&id=55a3c4aa"
import script from "./RelatedProductsV2.vue?vue&type=script&lang=js"
export * from "./RelatedProductsV2.vue?vue&type=script&lang=js"
import style0 from "./RelatedProductsV2.vue?vue&type=style&index=0&id=55a3c4aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports